import { useMemo } from "react";
import { motion } from "framer-motion";

export const Sparks = ({ count = 22 }) => {
  const sparks = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 4,
        duration: 2 + Math.random() * 3,
        drift: -20 + Math.random() * 40,
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="sparks-layer">
      {sparks.map((s) => (
        <motion.span
          key={s.id}
          className="spark"
          style={{ left: `${s.left}%`, top: `${s.top}%` }}
          initial={{ opacity: 0, y: 0, x: 0 }}
          animate={{ opacity: [0, 1, 0.6, 0], y: [-4, -60], x: [0, s.drift] }}
          transition={{ duration: s.duration, delay: s.delay, repeat: Infinity, ease: "easeOut" }}
        />
      ))}
    </div>
  );
};
